import { type MCPServerInfo } from '../../types';

const WrikeServer: MCPServerInfo = {
  serverId: 'WRIKE',
  name: 'Wrike',
  slug: 'wrike',
  description: 'Wrike remote MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.wrike.com/app/mcp/stream'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default WrikeServer;
